export default "__VITE_ASSET__Dw3$Deqj__"